import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import './BottomServiceBanner.css'
import { lP } from '../core.js'


export default function BottomServiceBanner({ show, message, cta, ctalink, onClose }) {
    return (
        <AnimatePresence>
            {show && (
                <motion.div
                    className="bottom-banner"
                    initial={{ y: 100, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    exit={{ y: 100, opacity: 0 }}
                    transition={{ type: "spring", stiffness: 300, damping: 25 }}
                >
                    <div className="banner-content">
                        <div>
                            <p className="banner-message">{message}</p>
                            <button className="banner-cta" onClick={() => lP(ctalink)}>
                                {cta}
                            </button>
                        </div>
                        <button className="banner-close" onClick={onClose}>&times;</button>
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    );
}